// What the Quick scan "saved" screen says, as a pure function of the session.

/** The photo count to show once a commit has returned: the server's `stored` when it said one, else the local count. */
export const photoCount = (local, stored) => (Number.isFinite(stored) ? stored : local);

/**
 * @param {object} a
 * @param {number} a.count      photos just committed (the local count)
 * @param {number|null} a.stored the server's count for the commit; wins over `count` when set
 * @param {string} a.picture    the item's picture url ("" when none)
 * @param {string} a.name       the item's name ("" for a new item)
 * @param {string} a.barcode    the new item's barcode ("" when none)
 * @param {boolean} a.autoReturn the automatic return is running
 * @param {boolean} a.tap        iOS: no scripted return, the link is a tap (Universal Link)
 * @param {string} a.returnUrl  quick.returnUrl ("" from the app's own gallery)
 * @param {boolean} a.desk       opened from the desktop QR: the desktop follows, so no button, spinner or return
 */
export function doneScreen({ count, stored = null, picture = "", name = "", barcode = "", autoReturn = false, returnUrl = "", tap = false, desk = false }) {
  const n = photoCount(count, stored);
  if (desk) {
    return { picture, title: name || barcode || "New item", pill: `Saved · ${n} new photo${n === 1 ? "" : "s"}`, spinner: false, line: "Opened on your computer", primary: null, desk: true };
  }
  return {
    picture,
    title: name || barcode || "New item",
    pill: `Saved · ${n} new photo${n === 1 ? "" : "s"}`,
    spinner: Boolean(returnUrl) && autoReturn,
    line: returnUrl ? (tap ? "" : autoReturn ? "Back to Shopify to choose how to enrich it" : "Tap below to go back to Shopify") : "",
    primary: returnUrl ? { label: tap ? "Back to Shopify" : "Back to Shopify now", href: returnUrl } : { label: "Back to captures", href: "" },
  };
}
